module.exports = __webpack_public_path__ + "img/top1.a83660ed.png";